import playgroundApi from "../playgroundApi";
import {logger} from "../log/logger";
import {LessonPreviewType} from "../../client/models/songs/LessonPreviewType";

class LessonPreviewPlay {
  /**
   * Records one press of Play on an arrangement's audio preview, for reporting.
   * Fire-and-forget: a failed request is logged, and never reaches the user or delays playback.
   */
  public record(lessonId: number, previewType: LessonPreviewType, seekPositionSeconds: number): void {
    playgroundApi.recordLessonPreviewPlay({lessonId, previewType, seekPositionSeconds}).catch((e) => {
      logger.api.error({message: `call to record lesson preview play failed:`, error: e as Error});
    });
  }
}

export const lessonPreviewPlay = new LessonPreviewPlay();
